export const login_url = "admin/login";
export const users_list = "/admin/list"
export const customer_login_url = "/auth/login";

export const add_branch_user_api = "admin/add-user"
export const add_agent = "admin/add-agent"
export const get_user_detais = "admin/details"

export const  resend_activation_link = "admin/resend-activation-link" //for only admins
export const set_password = "/admin/set-password"
export const admin_update_password = "/admin/update-password"
export const admin_update_status = "/admin/update-status"

export const user_update_password = "/customer/update-password" 

export const branch_list = "/admin/get-branch-list"
export const forgot_password = "/admin/forgot-password"
export const get_master_data = "/masterdata/get-master-data"

export const signup_customer = "/auth/signup-customer"
export const invite_customer = "/auth/invite-customer"
export const  add_subscriber = "/auth/add-subscriber"
export const  get_payment_link = "/auth/get-payment-link"
export const  cutomer_resend_activation_link = "/auth/resend-activation-link"

export const add_plan_touser = "/auth/add-plan-touser"
export const enquiry = "/auth/enquiry"
export const enquiry_otp = "/auth/enquiry-otp"
export const verify_otp  = "/auth/verify-account"
export const customer_forgot_password = "/auth/forgot-password"
export const customer_set_password = "/auth/set-password"

export const customer_list = "/customer/list"
export const subscribers_list = "/customer/subscribers-list"
export const lead_list = "/customer/applications-list"
export const apply_loan = "/customer/apply-loan"
export const constuser_subscription_list =  "/customer/user-subscriptions-list"

export const get_user_details = "/customer/get-customet-details"
export const getLoanApplicationDetailsApi =  "/customer/getloan-application-details"
export const updateLoanApplication = "/customer/update-loan-application-details"
export const updateCustomerDetails = "/customer/update-customer-details"
export const createAndupdateCustomerDetails = "/customer/create-update-customer-details"

export const enquiry_list_url = "/customer/enquiry/list"
export const enquiry_details = "/customer/enquiry/details"
export const enquirerToCustomer = "/auth/enquirer-to-customer"
export const get_ifsccodes_data ="./masterdata/get-ifsccodes-data"
export const get_configuration_list = "/masterdata/get-service-configuration"
export const add_service_type_configuration = "/masterdata/add-service-configuration"
export const edit_service_type_configuration = "/masterdata/edit-service-configuration"
export const get_dashboard_data_api = "/masterdata/get-dashboard-data"
export const support_ticket_create = "/support/ticket-request"
export const support_ticket_list = "/support/ticketRequest-list"